module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.showTriggerButton) ? _c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs",
      "variant": _vm.triggerButtonVariant
    },
    on: {
      "click": _vm.showChallanModal
    }
  }, [_vm._v("\n      " + _vm._s(_vm.triggerButtonText) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.inlineDisplay) ? _c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.challanList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    attrs: {
      "disabled": _vm.isExporting,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_vm._v("\n            " + _vm._s(_vm.exportButtonText) + "\n            "), (_vm.isExporting) ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Exporting..."
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mb-1 mr-2",
    attrs: {
      "size": "sm",
      "variant": "info",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "refresh",
      "aria-hidden": "true"
    }
  }, [_vm._v("refresh")]), _vm._v("\n            Refresh\n          ")], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "type": "search",
      "placeholder": "Search challans..."
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), (_vm.challanList.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('b-card', {
    staticClass: "bg-light"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total Challans:")]), _vm._v(" "), _c('div', {
    staticClass: "h6"
  }, [_vm._v(_vm._s(_vm.totalRows))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Disposed:")]), _vm._v(" "), _c('div', {
    staticClass: "h6 text-success"
  }, [_vm._v(_vm._s(_vm.disposedCount))]), _vm._v(" "), _c('small', {
    staticClass: "text-success"
  }, [_vm._v("₹" + _vm._s(_vm.disposedFineAmount))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Pending:")]), _vm._v(" "), _c('div', {
    staticClass: "h6 text-warning"
  }, [_vm._v(_vm._s(_vm.pendingCount))]), _vm._v(" "), _c('small', {
    staticClass: "text-warning"
  }, [_vm._v("₹" + _vm._s(_vm.pendingFineAmount))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total Fine:")]), _vm._v(" "), _c('div', {
    staticClass: "h6 text-info"
  }, [_vm._v("₹" + _vm._s(_vm.totalFineAmount))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Outstanding:")]), _vm._v(" "), _c('div', {
    staticClass: "h6 text-danger"
  }, [_vm._v("₹" + _vm._s(_vm.pendingFineAmount))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.challanList,
      "fields": _vm.challanFields,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "Status",
      fn: function(row) {
        return [_c('b-badge', {
          class: _vm.getStatusClass(row.item.Status),
          attrs: {
            "variant": _vm.getStatusVariant(row.item.Status)
          }
        }, [_vm._v("\n                " + _vm._s(row.item.Status) + "\n              ")])]
      }
    }, {
      key: "Fine Imposed",
      fn: function(row) {
        return [(row.item['Fine Imposed'] && row.item['Fine Imposed'] !== 'N/A') ? _c('span', [_vm._v("\n                ₹" + _vm._s(row.item['Fine Imposed']) + "\n              ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("N/A")])]
      }
    }, {
      key: "Received Amount",
      fn: function(row) {
        return [(row.item['Received Amount'] && row.item['Received Amount'] !== 'N/A') ? _c('span', [_vm._v("\n                ₹" + _vm._s(row.item['Received Amount']) + "\n              ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("N/A")])]
      }
    }, {
      key: "Challan Date/Time",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s((row.item['Challan Date/Time'])))])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              _vm.viewChallanDetails(row.item)
            }
          }
        }, [_c('md-icon', {
          attrs: {
            "icon": "visibility",
            "aria-hidden": "true"
          }
        }, [_vm._v("visibility")]), _vm._v("\n                View\n              ")], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.totalRows > _vm.perPage) ? _c('div', [_c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center",
      "size": "sm"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "details-modal",
    attrs: {
      "title": ("Challan Details - " + (_vm.selectedChallan ? _vm.selectedChallan['Challan No'] : 'N/A')),
      "size": "lg",
      "hide-footer": ""
    }
  }, [(_vm.selectedChallan) ? _c('div', [_c('b-row', _vm._l((_vm.selectedChallan), function(value, key) {
    return _c('b-col', {
      key: key,
      attrs: {
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatFieldName(key)) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(value || 'N/A'))])])])
  }))], 1) : _vm._e(), _vm._v(" "), [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideDetailsModal
    }
  }, [_vm._v("Close")])]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dff2756","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/VehicleChallanList.vue
// module id = 2490
// module chunks = 0